/* @flow */
import cx from 'classnames';
import Glyph from 'components/Glyph.jsx';
import Link from 'components/Link.jsx';
import React from 'react';

import './styles/share.scss';

export default class extends React.Component {
  static propTypes = {
    text: React.PropTypes.string.isRequired,
  };

  getLink = () => {
    return `https://www.twitter.com/home?status=${this.props.text}`;
  };

  render() {
    return (
      <Link
        target="_blank"
        href={this.getLink()}
        className={cx('Share', 'ShareTwitter', this.props.className)}>
        <Glyph
          className="Share-glyph ShareTwitter-glyph"
          size="large"
          name="twitter"
        />
        <span>Tweet</span>
      </Link>
    );
  }
}



// WEBPACK FOOTER //
// ./src/components/ShareTwitter.jsx